import React, { ReactNode, SyntheticEvent } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import styles from './styles.module.scss'
import layerStyles from 'styles/layer.module.scss'
import { animated as a, config, useSpring } from 'react-spring'

interface PopupProps {
  children: ReactNode
  left: number
  onCloseHandler: (event: SyntheticEvent<HTMLAnchorElement>) => void
  top: number
  useTouch: boolean
  width: number
}

/**
 * Popup mit Informationen zu einer bestimmten Gemeinde.
 */
export function Popup({
  children,
  left = window.innerWidth * 0.5 + window.pageXOffset,
  onCloseHandler = () => {},
  top = window.pageYOffset,
  useTouch = false,
  width = 300
}: PopupProps) {
  const style = useSpring({
    transform: `translate(${(window.innerWidth - width) *
      (left / window.innerWidth) +
      width / 2}px, ${top}px) translate(-50%, -100%) translateY(-2em)`,
    width: width,
    config: config.slow
  })

  let closeButton = null
  if (useTouch) {
    closeButton = (
      <a
        onTouchEnd={onCloseHandler}
        className={`ui basic icon close button ${styles.closeButton}`}
      >
        <i className='close icon' />
      </a>
    )
  }

  return (
    <a.div
      className={`ui raised compact segment ${styles.popup} ${layerStyles.layer}`}
      style={window.innerWidth > 599 ? style : {}}
    >
      {children}
      {closeButton}
    </a.div>
  )
}
